import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const fetchPublicPlans = createAsyncThunk('plans/fetchPublic', async (_, { rejectWithValue }) => {
  try {
    const res = await fetch('/api/subscriptions/plans');
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Failed to fetch plans');
    return data.plans;
  } catch (err) {
    return rejectWithValue(err.message);
  }
});

const plansSlice = createSlice({
  name: 'plans',
  initialState: { plans: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPublicPlans.pending,   (state) => { state.loading = true; state.error = null; })
      .addCase(fetchPublicPlans.fulfilled, (state, action) => { state.loading = false; state.plans = action.payload; })
      .addCase(fetchPublicPlans.rejected,  (state, action) => { state.loading = false; state.error = action.payload; });
  },
});

export default plansSlice.reducer;
